<template>
  <Layout>
    <div class="mb6" flex="box:last">
      <div class="mr2">
        <TradeName />
      </div>
      <div class="right" style="width:320px;" flex-box="0">
        <NewProdFocus class="mt6" />
        <DrugRecommendation />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../../layout';
import TradeName from '../../components/drugInformation/tradeName';
import NewProdFocus from '../../components/newProdFocus/Carousel';
import DrugRecommendation from '../../components/medicine/Recommend';
export default {
  components: {
    Layout,
    TradeName,
    NewProdFocus,
    DrugRecommendation,
  },
};
</script>

<style lang="scss"></style>
